import { isBefore } from 'date-fns'
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux'
import { Action } from 'redux'
import { getNestedProperty } from '@opallabs/lambda'
import { translations } from '@opallabs/satellite'
import { actions, getters } from '@opallabs/wormhole'
import { Notification, State } from '@opallabs/wormhole/types'
import { StateProps, DispatchProps, OwnProps } from './types'
import { NotificationsPanel } from '.'

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (
  state
) => {
  // Assume we're loading unless the loader is explicitly set to false
  const isLoading =
    getNestedProperty(state, 'loaders', 'notifications') === undefined
      ? true
      : getNestedProperty(state, 'loaders', 'notifications')

  return {
    isLoading,
    notifications: getters
      .mapPersonalPanelNotifications(state)
      .filter((notification: Notification) => {
        const typeArray = notification.type.split('.')
        if (typeArray.length < 2) {
          return false
        }
        const notificationStringTemplate = getNestedProperty(
          translations,
          typeArray[0],
          typeArray[1]
        )
        if (notificationStringTemplate === undefined) {
          return false
        }
        return true
      })
      .sort((a, b) => {
        if (isBefore(a.timestamp, b.timestamp)) {
          return 1
        }
        if (isBefore(b.timestamp, a.timestamp)) {
          return -1
        }
        return 0
      }),
  }
}

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  getNotifications: ({ page = 0, pageSize = 40 }): void => {
    dispatch(
      actions.getNotifications({ parent: 'notifications', pageSize, page })
    )
  },
  onItemClick: (notification: Notification): void => {
    ownProps.onNotificationClick(notification)
  },
  onRemoveNotification: (id: string): void => {
    dispatch(actions.removeNotification(id))
  },
  createCheckpoint: (notifications: Notification[]): Action =>
    dispatch(
      actions.createCheckpoints({
        tab: 'Notification',
        items: notifications,
      })
    ),
})

export const ConnectedNotificationPanel = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsPanel)
